import { useTranslation } from 'react-i18next';
import type { TocItem } from '@/legal/utils/tocExtractor';

interface Props {
  items: TocItem[];
}

export function TableOfContents({ items }: Props) {
  const { t } = useTranslation('legal');

  return (
    <nav aria-label={t('toc.label')} className="legal-toc pr-4">
      <h2 className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        {t('toc.label')}
      </h2>
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.anchor}>
            <a
              href={`#${item.anchor}`}
              className="block border-l-2 border-transparent py-1 pl-3 text-sm text-text-secondary transition hover:text-text-primary"
            >
              {item.text}
            </a>
            {item.children && item.children.length > 0 && (
              <ul className="mt-1 space-y-1 pl-3">
                {item.children.map((child) => (
                  <li key={child.anchor}>
                    <a
                      href={`#${child.anchor}`}
                      className="block border-l-2 border-transparent py-1 pl-3 text-xs text-text-secondary transition hover:text-text-primary"
                    >
                      {child.text}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
